import { render, staticRenderFns } from "./plus-20.vue?vue&type=template&id=34959d92&scoped=true"
import script from "./plus-20.vue?vue&type=script&lang=js"
export * from "./plus-20.vue?vue&type=script&lang=js"
import style0 from "./plus-20.vue?vue&type=style&index=0&id=34959d92&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34959d92",
  null
  
)

export default component.exports